// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --color-primary: #000000;
  --color-white: #ffffff;
  --color-red: #ff0000;
  --color-blue: #00a2ed;
  --color-secondary: rgb(34, 34, 34);
  --font-white: rgb(250, 249, 248);
  --font-light-grey: #a4a4a4;
  --font-medium: 18px !important;
  --medium-screen: 640px !important;
  --small-screen: 960px; }

.container {
  position: relative;
  overflow: hidden; }

.container:before {
  content: "";
  position: absolute;
  top: 0;
  left: 10px;
  margin-left: -1px;
  width: 2px;
  height: 100%;
  background: #ccd1d9;
  z-index: 1; }

.timeline-block {
  display: flex;
  justify-content: space-between;
  clear: both; }

.timeline-block-right {
  float: right; }

.marker {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 2px solid #f5f7fa;
  background: #4fc1e9;
  margin-top: 10px;
  z-index: 9999; }

.timeline-content {
  width: 95%;
  padding: 0 15px; }

.timeline-content span {
  font-size: 15px;
  color: var(--font-light-grey); }

.positon-desc {
  font-size: 14px;
  line-height: 1.5em;
  word-spacing: 1px;
  color: var(--font-light-grey); }

@media screen and (max-width: 768px) {
  .container:before {
    left: 8px;
    width: 2px; }
  .timeline-block {
    width: 100%;
    margin-bottom: 30px; }
  .timeline-block-right {
    float: none; }
  .timeline-block-left {
    float: none;
    direction: ltr; } }

.org-img {
  height: 75px !important; }

.project-card {
  background: #323130 !important; }

.link-to-project {
  color: var(--font-color-white); }
  .link-to-project .ms-Button-flexContainer .ms-Button-icon {
    font-size: 20px !important; }

.link-to-project:hover {
  color: var(--color-blue);
  background-color: #323130 !important; }

.mail-card {
  border: 2px solid #f5f7fa; }
`, "",{"version":3,"sources":["webpack://./src/theme/_variables.scss","webpack://./src/components/applications/about/about.scss"],"names":[],"mappings":"AAAA;EACC,wBAAgB;EAChB,sBAAc;EACd,oBAAY;EACZ,qBAAa;EACb,kCAAkB;EAElB,gCAAa;EACb,0BAAkB;EAElB,8BAAc;EAEd,iCAAgB;EAChB,qBAAe,EAAA;;ACXhB;EACC,kBAAkB;EAClB,gBAAgB,EAAA;;AAGjB;EACC,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,iBAAiB;EACjB,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,UAAU,EAAA;;AAGX;EACC,aAAa;EAIb,8BAA8B;EAC9B,WAAW,EAAA;;AAGZ;EACC,YAAY,EAAA;;AAGb;EACC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa,EAAA;;AAGd;EACC,UAAU;EACV,eAAe,EAAA;;AAGhB;EACC,eAAe;EACf,6BAA6B,EAAA;;AAG9B;EACC,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,6BAA6B,EAAA;;AAG9B;EACC;IACC,SAAS;IACT,UAAU,EAAA;EAEX;IACC,WAAW;IACX,mBAAmB,EAAA;EAEpB;IACC,WAAW,EAAA;EAGZ;IACC,WAAW;IACX,cAAc,EAAA,EACd;;AAGF;EACC,uBAAuB,EAAA;;AAGxB;EACC,8BAAsC,EAAA;;AAGvC;EACC,8BAA8B,EAAA;EAD/B;IAIG,0BAA0B,EAAA;;AAK7B;EACC,wBAAwB;EACxB,oCAA4C,EAAA;;AAG7C;EACC,yBAAyB,EAAA","sourcesContent":[":root {\n\t--color-primary: #000000;\n\t--color-white: #ffffff;\n\t--color-red: #ff0000;\n\t--color-blue: #00a2ed;\n\t--color-secondary: rgb(34, 34, 34);\n\n\t--font-white: rgb(250, 249, 248);\n\t--font-light-grey: #a4a4a4;\n\n\t--font-medium: 18px !important;\n\n\t--medium-screen: 640px !important;\n\t--small-screen: 960px;\n}\n","@import \"../../../theme/variables\";\n\n.container {\n\tposition: relative;\n\toverflow: hidden;\n}\n\n.container:before {\n\tcontent: \"\";\n\tposition: absolute;\n\ttop: 0;\n\tleft: 10px;\n\tmargin-left: -1px;\n\twidth: 2px;\n\theight: 100%;\n\tbackground: #ccd1d9;\n\tz-index: 1;\n}\n\n.timeline-block {\n\tdisplay: flex;\n\t-webkit-box-pack: justify;\n\t-webkit-justify-content: space-between;\n\t-moz-box-pack: justify;\n\tjustify-content: space-between;\n\tclear: both;\n}\n\n.timeline-block-right {\n\tfloat: right;\n}\n\n.marker {\n\twidth: 16px;\n\theight: 16px;\n\tborder-radius: 50%;\n\tborder: 2px solid #f5f7fa;\n\tbackground: #4fc1e9;\n\tmargin-top: 10px;\n\tz-index: 9999;\n}\n\n.timeline-content {\n\twidth: 95%;\n\tpadding: 0 15px;\n}\n\n.timeline-content span {\n\tfont-size: 15px;\n\tcolor: var(--font-light-grey);\n}\n\n.positon-desc {\n\tfont-size: 14px;\n\tline-height: 1.5em;\n\tword-spacing: 1px;\n\tcolor: var(--font-light-grey);\n}\n\n@media screen and (max-width: 768px) {\n\t.container:before {\n\t\tleft: 8px;\n\t\twidth: 2px;\n\t}\n\t.timeline-block {\n\t\twidth: 100%;\n\t\tmargin-bottom: 30px;\n\t}\n\t.timeline-block-right {\n\t\tfloat: none;\n\t}\n\n\t.timeline-block-left {\n\t\tfloat: none;\n\t\tdirection: ltr;\n\t}\n}\n\n.org-img {\n\theight: 75px !important;\n}\n\n.project-card {\n\tbackground: rgb(50, 49, 48) !important;\n}\n\n.link-to-project {\n\tcolor: var(--font-color-white);\n\t.ms-Button-flexContainer {\n\t\t.ms-Button-icon {\n\t\t\tfont-size: 20px !important;\n\t\t}\n\t}\n}\n\n.link-to-project:hover {\n\tcolor: var(--color-blue);\n\tbackground-color: rgb(50, 49, 48) !important;\n}\n\n.mail-card {\n\tborder: 2px solid #f5f7fa;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
